import { useMemo } from "react"

import { api, type RouterOutputs } from "~/utils/api"
import type { StoreValues } from "../drafts/storeDraftState"

type StoreSetupRecord = RouterOutputs["allocation"]["getStoreSetup"][number]

export type StoreSetupRow = {
  id: string
  name: string
  code: string | null
  country: string | null
  ruleId: string | null
  values: StoreValues
}

const toRow = ({
  id,
  name,
  code,
  country,
  ruleId,
  ...values
}: StoreSetupRecord): StoreSetupRow => ({
  id,
  name,
  code,
  country,
  ruleId,
  values,
})

export function useStoreSetup() {
  const query = api.allocation.getStoreSetup.useQuery()
  const stores = useMemo(() => (query.data ?? []).map(toRow), [query.data])
  return { stores, isLoading: query.isLoading }
}
